export type ProductNotifyType = 'cart' | 'favourite';

export type ProductNotifyOptions = {
	id?: string;
	type: ProductNotifyType;
	title: string;
	price: string;
	size?: string;
	color?: string;
	image: string;
	link?: string;
	linkText?: string;
	delay?: number;
};

const productNotifyHeadings: Record<ProductNotifyType, string> = {
	cart: 'Товар добавлен в корзину',
	favourite: 'Товар добавлен в избранное',
};

const productNotifyLinkText: Record<ProductNotifyType, string> = {
	cart: 'Перейти в корзину',
	favourite: 'Перейти в избранное',
};

const productNotifyLinkHref: Record<ProductNotifyType, string> = {
	cart: 'cart.html',
	favourite: 'account-favourites.html',
};

const renderAttrs = (size?: string, color?: string): string => {
	if (!size && !color) return '';

	const attrs = [
		size &&
			`<div class="product-notify__attr">
				<span class="product-notify__attr-name">Размер</span>
				<span class="product-notify__attr-value">${size}</span>
			</div>`,
		color &&
			`<div class="product-notify__attr">
				<span class="product-notify__attr-name">Цвет</span>
				<span class="product-notify__attr-value">${color}</span>
			</div>`,
	]
		.filter(Boolean)
		.join('');

	return `<div class="product-notify__attrs">${attrs}</div>`;
};

export const getProductNotifyContent = (options: ProductNotifyOptions): string => {
	const { type, title, price, size, color, image } = options;
	const heading = productNotifyHeadings[type];
	const linkText = options.linkText || productNotifyLinkText[type];
	const linkHref = options.link || productNotifyLinkHref[type];

	return `
		<div class="product-notify__head">
			<div class="product-notify__heading">${heading}</div>
		</div>
		<div class="product-notify__product">
			<div class="product-notify__image">
				<img src="${image}" alt="${title}">
			</div>
			<div class="product-notify__info">
				<div class="product-notify__title">${title}</div>
				<div class="product-notify__price">${price}</div>
				${renderAttrs(size, color)}
			</div>
		</div>
		<a class="product-notify__link link link--underline" href="${linkHref}">${linkText}</a>
	`;
};
